import { useMediaQuery } from "react-responsive";
import { Header } from "../Header";
import { Breadcrumb } from "../Breadcrumb";

export function LearningContentLayout({ grade, page, resourcePage, children }) {
  const isSmall = useMediaQuery({ query: "(max-width: 472px)" });
  return (
    <section className="learningResources my-md-5 my-sm-1 p-lg-0 p-2 p-sm-2 py-sm-4 col-md-9 col-sm-12  mx-auto">
      <div className="container">
        {!isSmall ? (
          <Header title={grade} subtitle={page} breadcrumb={resourcePage} />
        ) : (
          <Breadcrumb
            className="mb-4"
            items={resourcePage.split(" > ").map((page) => ({ label: page }))}
          />
        )}
        {children}
      </div>
    </section>
  );
}
